import * as React from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { Checkbox } from './Checkbox';
import { ConfirmationModal } from './ConfirmationModal';
import { Button } from './buttons/Button';
import { axios } from '../api';
import { BOTTOM_TOAST, generateErrorMsg } from '../utils';

interface ResetMFAProps {
  email: string;
}

export const ResetMFA = ({ email }: ResetMFAProps) => {
  const [showModal, setShowModal] = useState(false);
  const [isDeviceStolen, setIsDeviceStolen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
    setIsDeviceStolen(false);
  };

  const handleResetMFA = () => {
    setIsLoading(true);
    axios
      .post(`totp/reset/`, {
        email,
        hard_reset: isDeviceStolen,
      })
      .then(() => {
        toast.success(
          `MFA reset for ${email}. They will set up their authenticator app on next login.`,
          BOTTOM_TOAST
        );
        handleCloseModal();
      })
      .catch((e) => {
        toast.error(generateErrorMsg(e), BOTTOM_TOAST);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Button
        variant="grey"
        label="Reset MFA"
        textClassName="text-sm"
        onClick={() => setShowModal(true)}
      />
      {showModal && (
        <ConfirmationModal
          title={`Are you sure you want to reset MFA for ${email}?`}
          confirmLabel="Reset MFA"
          cancelLabel="Cancel"
          onConfirm={handleResetMFA}
          onCancel={handleCloseModal}
          isProcessLoading={isLoading}
          customMessage={
            <div className="flex justify-center mb-4">
              <Checkbox
                label="Device has been stolen"
                isChecked={isDeviceStolen}
                onChange={setIsDeviceStolen}
                disabled={isLoading}
              />
            </div>
          }
        />
      )}
    </>
  );
};
